import HTTP from '@/services/http'
import type { OneConfigRoot } from '@yy/one-config/libs/one-config'

/**
 * 获取多语言平台的页面配置
 * @param key 配置的key
 */
export const getConfig = async (key?: string) => {
  const { data } = await HTTP.get(process.env.CONFIG_URL, { withCredentials: false })
  return key ? data[key] : data
}

/** 获取oms配置 */
export const getTargetOmsConfig = async <T extends keyof OneConfigRoot>(key: T) => {
  const url = `${process.env.CONFIG_URL_PREFIX}/${key.toLowerCase()}.json`
  const res = await fetch(url)
  return res.json() as unknown as OneConfigRoot[T]
}
